import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import { Button, Heading6, Icon } from "@material-tailwind/react";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Loader from "components/Loader";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearFlashMessages } from "actions/flashMessagesAction";
import { useEffect } from "react";
import FlashMessageList from "components/flash/FlashMessageList";
import { resetErrors } from "actions/flashMessagesAction";
import moment from "moment";

export default function MemberCardTable(props) {
  const { flash } = useSelector((state) => state.flash);
  const errorMsg = useSelector((state) => state.errors);
  const [flashMsg, setFlashMsg] = useState([]);
  const [tableView, setTableView] = useState("0");
  const [errorAlert, setErrorAlert] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [modalContent, setModalContent] = useState("");

  const dispatch = useDispatch();

  const clearFlash = () => {
    setTimeout(() => {
      dispatch(clearFlashMessages());
      setFlashMsg([]);
    }, 8000);
  };
  useEffect(() => {
    dispatch(resetErrors());
    if (flash && flash.length > 0) {
      setFlashMsg(flash);
      clearFlash();
    }
    if (errorMsg.message) {
      setErrorAlert(errorMsg.message);
    }
  }, [flash, errorMsg.message, setErrorAlert]);

  function handleChange(e) {
    setTableView(e.target.value);
  }

  // const archiveNow = ({ member, val }) => {
  //   dispatch(archive_member({ id: member, is_archived: val }));
  // };
  const { members, loading, name } = props;

  function previewUser(id) {
    setModalContent(
      members
        .filter((v) => v.id === id)
        .map((item) => (
          <div key={item.id}>
            <p className={"flexIt"}>
              <span>Name:</span>{" "}
              <span>
                {item.first_name && item.first_name}{" "}
                {item.first_name && item.last_name}
              </span>
            </p>
            <p className={"flexIt"}>
              <span>Email:</span> <span>{item.email}</span>
            </p>
            <p className={"flexIt"}>
              <span>Phone:</span> <span>{item.phone}</span>
            </p>
            <p className={"flexIt"}>
              <span>Address:</span> <span>{item.address}</span>
            </p>
            <p className={"flexIt"}>
              <span>State:</span> <span>{item.state}</span>
            </p>
            <p className={"flexIt"}>
              <span>City:</span> <span>{item.city}</span>
            </p>
            <p className={"flexIt"}>
              <span>Plan:</span>{" "}
              <span style={{ fontStyle: "italic", color: "green" }}>
                {item.plan_id == "personal" ? "Personal" : "Personal Plus"}
              </span>
            </p>
            <p className={"flexIt"}>
              <span>Status:</span>{" "}
              <span>{item.status == "active" ? "Active" : "Inactive"}</span>
            </p>
            <p className={"flexIt"}>
              <span>Migrated to ClpApp:</span>{" "}
              <span>{item.is_synced !== 1 ? "No" : "Yes"}</span>
            </p>
            <p className={"flexIt"}>
              <span>Created At:</span>{" "}
              <span>
                {moment(item.created_at).format("MM/DD/YYYY hh:mm A")}
              </span>
            </p>
            <hr className="mt-3 mb-3" />
            <Heading6 color="gray">Reseller</Heading6>
            <p className={"flexIt"}>
              <span>Name:</span>
              <span>{item.users.name}</span>
            </p>
            <p className={"flexIt"}>
              <span>Email:</span>
              <span>{item.users.email}</span>
            </p>
          </div>
        ))
    );
    setShowModal(true);
  }

  let setContent;
  if (loading) {
    setContent = (
      <tr>
        <td colSpan="6">
          <Loader />
        </td>
      </tr>
    );
  } else if (members.length === 0) {
    setContent = (
      <tr>
        <th
          colSpan="6"
          className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-center"
        >
          No records found.
        </th>
      </tr>
    );
  } else {
    setContent = members
      .filter((v) =>
        tableView !== "2"
          ? typeof v.is_archived !== "undefined" &&
            v.is_archived.toString() === tableView
          : v
      )
      .map((item) => (
        <tr key={item.id}>
          <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
            {item.first_name && item.first_name}{" "}
            {item.first_name && item.last_name}
          </th>
          <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
            {item.email && item.email}
          </th>
          <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
            {item.plan_id === "personal" ? "Personal" : "Personal Plus"}
          </th>
          <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
            {item.phone}
          </th>
          <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
            <b style={{ fontStyle: "italic" }}>{item.users.name}</b>
          </th>
          <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
            {moment(item.created_at).format("MM/DD/YYYY hh:mm A")}
          </th>
          <th className="flex border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
            {/* {item.is_synced === "0" ||
              (item.is_synced === 0 && (
                <NavLink
                  to={`/user/edit/${item.id}`}
                  className="mr-1 false flex items-center justify-center gap-1 font-bold outline-none uppercase tracking-wider focus:outline-none focus:shadow-none transition-all duration-300 rounded-full w-8 h-8 p-0 grid place-items-center text-xs leading-normal text-white bg-blue-500 hover:bg-blue-700 focus:bg-blue-400 active:bg-blue-800 shadow-md-blue hover:shadow-lg-blue"
                  title="Edit User"
                >
                  <Icon name="edit" size="sm" color="white" />
                </NavLink>
              ))} */}
            {/* {item.is_archived.toString() === "0" ? (
              <Button
                color="red"
                buttonType="filled"
                size="sm"
                rounded={true}
                block={false}
                iconOnly={true}
                ripple="light"
                onClick={() => archiveNow({ member: item.id, val: "1" })}
                title="Archive User"
              >
                <Icon name="archive" size="sm" />
              </Button>
            ) : (
              <Button
                color="yellow"
                buttonType="filled"
                size="sm"
                rounded={true}
                block={false}
                iconOnly={true}
                ripple="light"
                onClick={() => archiveNow({ member: item.id, val: "0" })}
                title="Unarchive User"
              >
                <Icon name="unarchive" size="sm" />
              </Button>
            )} */}
            <Button
              color="orange"
              buttonType="filled"
              size="sm"
              rounded={true}
              block={false}
              iconOnly={true}
              ripple="light"
              onClick={(e) => previewUser(item.id)}
              title="Preview User"
            >
              <Icon name="face" size="sm" />
            </Button>
          </th>
        </tr>
      ));
  }

  return (
    <Card>
      <CardHeader color="orange" contentPosition="left" className={"flexIt"}>
        <h2 className="text-white text-2xl">{name}</h2>
        {/* <div style={{ fontSize: "17px", fontStyle: "italic" }}>
          <input
            type="radio"
            name="view"
            value="2"
            style={{
              height: "18px",
              width: "18px",
              verticalAlign: "text-top",
              cursor: "pointer",
            }}
            checked={tableView === "2"}
            onChange={handleChange}
          />
          <span style={{ marginRight: "10px" }}>All</span>
          <input
            type="radio"
            name="view"
            value="1"
            style={{
              height: "18px",
              width: "18px",
              verticalAlign: "text-top",
              cursor: "pointer",
            }}
            checked={tableView === "1"}
            onChange={handleChange}
          />
          <span style={{ marginRight: "10px" }}>Archived</span>
          <input
            type="radio"
            name="view"
            value="0"
            style={{
              height: "18px",
              width: "18px",
              verticalAlign: "text-top",
              cursor: "pointer",
            }}
            checked={tableView === "0"}
            onChange={handleChange}
          />
          <span style={{ marginRight: "10px" }}>Unarchived</span>
        </div> */}
      </CardHeader>
      <CardBody>
        <div className="overflow-x-auto">
          {flashMsg && (
            <FlashMessageList
              messages={
                Array.isArray(flashMsg)
                  ? flashMsg.filter(
                      (f) =>
                        f.eventFor === "member_update" ||
                        f.eventFor === "member_create"
                    )
                  : {}
              }
            />
          )}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr key="head">
                <th className="px-2 text-purple-500 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left">
                  Name
                </th>
                <th className="px-2 text-purple-500 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left">
                  Email
                </th>
                <th className="px-2 text-purple-500 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left">
                  Plan
                </th>
                <th className="px-2 text-purple-500 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left">
                  Phone
                </th>
                <th className="px-2 text-purple-500 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left">
                  Reseller
                </th>
                <th className="px-2 text-purple-500 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left">
                  Created At
                </th>

                <th className="px-2 text-purple-500 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>{setContent}</tbody>
          </table>
        </div>
      </CardBody>
      <Modal
        size="regular"
        active={showModal}
        toggler={() => setShowModal(false)}
      >
        <ModalHeader toggler={() => setShowModal(false)}>
          Preview User
        </ModalHeader>
        <ModalBody>
          <div
            className="text-base leading-relaxed text-gray-600 font-normal"
            style={{ width: "300px" }}
          >
            {modalContent}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={(e) => setShowModal(false)}
            ripple="dark"
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
}
